var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tooltip rounded-md px-2 text-sm font-semibold opacity-0 shadow-md",class:`text-${_vm.color} bg-${_vm.background}`,staticStyle:{"padding-top":"4px","padding-bottom":"5px","z-index":"15"},domProps:{"innerHTML":_vm._s(_vm.icon ? _vm.icon + _vm.text : _vm.text)}})
}
var staticRenderFns = []

export { render, staticRenderFns }